// extracted by mini-css-extract-plugin
export default {"hidden":"downloadPurchasePDFModal_hidden__I-Abx"};